import { socketUrl } from "../../../services/ApiConfig";
export const socketEvent = {
  initiateChat: "initiateChat",
  joinChatRoom: "joinChatRoom",
  sendMessage: "sendMessage",
  userMessage: "usermessage",
};
